export const CREATE_SECTOR_MUTATION = `
  mutation CreateSector($object: sectors_insert_input!) {
    insert_sectors_one(object: $object) {
      id
      sector_name
      sector_description
      sector_status
      company_id
      created_at
      updated_at
      company {
        id
        name
      }
    }
  }
`;

export const UPDATE_SECTOR_MUTATION = `
  mutation UpdateSector($id: Int!, $set: sectors_set_input!) {
    update_sectors_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      sector_name
      sector_description
      sector_status
      company_id
      created_at
      updated_at
      company {
        id
        name
      }
    }
  }
`;

export const DELETE_SECTOR_MUTATION = `
  mutation DeleteSector($id: Int!) {
    delete_sectors_by_pk(id: $id) {
      id
      sector_name
    }
  }
`; 